import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import imagemEsquerda from "../assets/feed_01.png";
import Cookies from "js-cookie";
import { ref, set } from "firebase/database";
import { database } from "../config/firebaseClient";
import { useAuth } from "../context/AuthContext";


export function Register() {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isOfAge, setIsOfAge] = useState(false);
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();


  const handleRegister = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setIsLoading(true);

    if (!fullName.trim() || fullName.length < 3) {
      setError("Nome completo deve ter pelo menos 3 caracteres.");
      setIsLoading(false);
      return;
    }

    if (!email.trim() || !email.includes("@")) {
      setError("Digite um email válido.");
      setIsLoading(false);
      return;
    }

    if (password.length < 6) {
      setError("A senha deve ter no mínimo 6 caracteres.");
      setIsLoading(false);
      return;
    }

    if (!isOfAge) {
      setError("Você precisa confirmar que é maior de 18 anos.");
      setIsLoading(false);
      return;
    }

    if (!acceptedTerms) {
      setError("Você precisa aceitar os Termos de Uso e a Política de Privacidade.");
      setIsLoading(false);
      return;
    }

    // Garantir o cookie "entradaCompleta"
    if (!Cookies.get("entradaCompleta")) {
      const fallback = {
        params: {},
        referer: document.referrer || null,
        recebidoEm: new Date().toISOString(),
      };

      Cookies.set("entradaCompleta", JSON.stringify(fallback), {
        expires: 7,
        sameSite: "None",
        secure: true,
      });
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          nome: fullName,
          email,
          password,
          source: localStorage.getItem("source"),
          sourceAfiliado: localStorage.getItem("sourceAfiliado"),
          entradaCompleta: JSON.parse(Cookies.get("entradaCompleta") || "null")
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Erro desconhecido ao registrar.");
      }

      // Rastreia conversão Offer18
      await trackConversion();

      try {
        await login(email, password); // loga automaticamente
        setSuccess("Cadastro realizado com sucesso! Redirecionando...");
        setIsLoading(false);
        setTimeout(() => navigate("/offers"), 1000); // redireciona pro painel
      } catch (loginError) {
        console.error("Erro ao logar após cadastro:", loginError);
        setError("Cadastro feito, mas houve erro ao logar.");
        setIsLoading(false);
      }

    } catch (err) {
      setError(err.message);
      setIsLoading(false);
    }
  };

    const trackConversion = () => {
    return new Promise((resolve, reject) => {
      try {
        const tid = localStorage.getItem("tid");

        if (!tid) {
          console.warn("⚠️ tid não encontrado. Pixel não será disparado.");
          resolve();
          return;
        }

        const iframe = document.createElement("iframe");
        iframe.src = `https://cashbet10532158.o18a.com/p?o=21620528&m=25190&event=lead&tid=${tid}`;
        iframe.width = "0";
        iframe.height = "0";
        iframe.style.display = "none";

        iframe.onload = () => {
          console.log("✅ Conversão rastreada com sucesso (cashbet Offer18 com tid)");
          resolve();
        };

        iframe.onerror = (error) => {
          console.error("❌ Erro ao rastrear conversão:", error);
          reject(error);
        };

        document.body.appendChild(iframe);
      } catch (error) {
        console.error("❌ Erro ao rastrear conversão:", error);
        reject(error);
      }
    });
  };


  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100 px-4">
      {/* Imagem esquerda */}
      <img
        src={imagemEsquerda}
        alt="Cashback Promo"
        className="hidden md:block w-full max-w-md h-full object-cover mr-8 rounded"
      />

      {/* Formulário */}
      <div className="bg-white shadow p-6 rounded max-w-md w-full">
        <h1 className="text-2xl font-bold mb-4">Crie sua conta na Cashbet</h1>
        {error && <p className="text-red-500 mb-4">{error}</p>}
        {success && <p className="text-green-600 mb-4">{success}</p>}

        <form onSubmit={handleRegister}>
          <div className="mb-4">
            <label className="block mb-2">Nome Completo</label>
            <input
              type="text"
              className="w-full p-2 border rounded"
              placeholder="Digite seu nome completo"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
            />
          </div>

          <div className="mb-4">
            <label className="block mb-2">Email</label>
            <input
              type="email"
              className="w-full p-2 border rounded"
              placeholder="Digite seu email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="mb-4">
            <label className="block mb-2">Senha</label>
            <input
              type={showPassword ? "text" : "password"}
              className="w-full p-2 border rounded"
              placeholder="A senha deve ter no mínimo 6 caracteres"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <div className="flex items-center mt-2">
              <input
                type="checkbox"
                className="mr-2"
                checked={showPassword}
                onChange={() => setShowPassword(!showPassword)}
              />
              <label>Mostrar senha</label>
            </div>
          </div>

          <div className="flex items-center mb-2">
            <input
              type="checkbox"
              className="mr-2"
              checked={isOfAge}
              onChange={() => setIsOfAge(!isOfAge)}
            />
            <label>Sou maior de 18 anos</label>
          </div>

          <div className="flex items-start mb-6">
            <input
              type="checkbox"
              className="mr-2 mt-1"
              checked={acceptedTerms}
              onChange={() => setAcceptedTerms(!acceptedTerms)}
            />
            <label className="text-sm leading-snug">
              Aceito os{" "}
              <Link
                to="/termos"
                className="font-bold text-blue-600 hover:underline"
                target="_blank"
              >
                Termos de Uso
              </Link>{" "}
              e a{" "}
              <Link
                to="/privacidade"
                className="font-bold text-blue-600 hover:underline"
                target="_blank"
              >
                Política de Privacidade
              </Link>
            </label>
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className={`w-full p-2 rounded-full text-white transition ${
              isLoading ? "bg-gray-400" : "bg-gray-500 hover:bg-gray-600"
            }`}
          >
            {isLoading ? "Criando conta..." : "Criar Conta"}
          </button>
        </form>

        <p className="text-center text-sm text-gray-700 mt-4">
          Já possui cadastro?{" "}
          <Link to="/login" className="text-blue-600 hover:underline font-medium">
            Faça login
          </Link>
        </p>
      </div>
    </div>
  );
}
